import { render, staticRenderFns } from "./LanceAutomatico.vue?vue&type=template&id=05c772cc"
import script from "./LanceAutomatico.vue?vue&type=script&lang=js"
export * from "./LanceAutomatico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports